import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';

import Card from '../Card';

import type { CardGridItem } from './types';

interface CardGridProps {
  cards: CardGridItem[];
}

const CardGrid = ({ cards }: CardGridProps) => (
  <Box
    sx={{
      width: '100%',
      maxWidth: 1360,
      mx: 'auto',
      alignSelf: 'center',
      '& .MuiGrid-container': {
        justifyContent: 'center',
      },
      '& .MuiGrid-container > .MuiGrid-root': {
        display: 'flex',
      },
      '& .MuiCard-root': {
        minHeight: 290,
        width: '100%',
      },
    }}
  >
    <Grid container spacing={3}>
      {cards.map((card) => (
        <Grid key={card.id} size={{ xs: 12, md: 6, lg: 4 }}>
          <Card
            title={card.title}
            description={card.description}
            icon={card.icon}
            actionLabel={card.actionLabel}
            to={card.to}
          />
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default CardGrid;
export type { CardGridItem } from './types';
